/**
 * 图片资源统一管理
 */

// 所有图片统一导出（按字母顺序排列，方便查找）
export const images = {
  // A
  ai: new URL('./images/ai.png', import.meta.url).href,
  aiFit: new URL('./images/ai_fit.png', import.meta.url).href,
  aiImage: new URL('./images/ai_image.png', import.meta.url).href,
  aiVideo: new URL('./images/ai_video.png', import.meta.url).href,
  aiWearable: new URL('./images/ai_wearable.png', import.meta.url).href,
  alipay: new URL('./images/alipay.png', import.meta.url).href,
  alipayPay: new URL('./images/alipay_pay.png', import.meta.url).href,
  arrow: new URL('./images/arrow.png', import.meta.url).href,
  audioThumb: new URL('./images/audio_thumb.png', import.meta.url).href,
  audioThumb02: new URL('./images/audio_thumb_02.png', import.meta.url).href,
  arrowBlack: new URL('./images/arrow_black.png', import.meta.url).href,
  arrowInvite: new URL('./images/arrow_invite.png', import.meta.url).href,
  asset: new URL('./images/asset.png', import.meta.url).href,
  avatar: new URL('./images/avatar.png', import.meta.url).href,

  // B
  brandWatermark: new URL('./images/brand_watermark.png', import.meta.url).href,

  // C
  changeModel: new URL('./images/change_model.png', import.meta.url).href,
  camera: new URL('./images/camera.png', import.meta.url).href,
  cameraUpload: new URL('./images/camera_upload.png', import.meta.url).href,
  check: new URL('./images/check.png', import.meta.url).href,
  check1: new URL('./images/check1.png', import.meta.url).href,
  check2: new URL('./images/check2.png', import.meta.url).href,
  check3: new URL('./images/check3.png', import.meta.url).href,
  checked1: new URL('./images/checked1.png', import.meta.url).href,
  checkedActive: new URL('./images/checked_active.png', import.meta.url).href,
  checkedNo: new URL('./images/checked_no.png', import.meta.url).href,
  choose: new URL('./images/choose.png', import.meta.url).href,
  clear: new URL('./images/clear.png', import.meta.url).href,
  clear2: new URL('./images/clear2.png', import.meta.url).href,
  close: new URL('./images/close.png', import.meta.url).href,
  close2: new URL('./images/close2.png', import.meta.url).href,
  close3: new URL('./images/close3.png', import.meta.url).href,
  close4: new URL('./images/close4.png', import.meta.url).href,
  collect: new URL('./images/collect.png', import.meta.url).href,
  collected: new URL('./images/collected.png', import.meta.url).href,
  coin: new URL('./images/coin.png', import.meta.url).href,
  coin1: new URL('./images/coin1.png', import.meta.url).href,
  coin2: new URL('./images/coin2.png', import.meta.url).href,
  coin3: new URL('./images/coin3.png', import.meta.url).href,

  creative: new URL('./images/creative.png', import.meta.url).href,
  copy: new URL('./images/copy.png', import.meta.url).href,
  customer: new URL('./images/customer.png', import.meta.url).href,
  customerCode: new URL('./images/customer_code.png', import.meta.url).href,
  closePay: new URL('./images/close_pay.png', import.meta.url).href,
  crown: new URL('./images/crown.png', import.meta.url).href,

  // D
  del: new URL('./images/del.png', import.meta.url).href,
  deleteRed: new URL('./images/del_red.png', import.meta.url).href,
  delete: new URL('./images/delete.png', import.meta.url).href,
  delete2: new URL('./images/delete2.png', import.meta.url).href,
  dislike: new URL('./images/dislike.png', import.meta.url).href,
  down: new URL('./images/down.png', import.meta.url).href,
  download: new URL('./images/download.png', import.meta.url).href,
  downloadIcon: new URL('./images/download_icon.png', import.meta.url).href,
  date: new URL('./images/date.png', import.meta.url).href,

  // E
  edit: new URL('./images/edit.png', import.meta.url).href,
  editWhite: new URL('./images/edit_white.png', import.meta.url).href,

  // F
  failImgPrimary: new URL('./images/fail_img_primary.png', import.meta.url).href,
  failVideoPrimary: new URL('./images/fail_video_primary.png', import.meta.url).href,

  // I
  img: new URL('./images/img.png', import.meta.url).href,
  imgEdit: new URL('./images/img_edit.png', import.meta.url).href,
  imgVideo: new URL('./images/img_video.png', import.meta.url).href,
  inspiration: new URL('./images/inspiration.png', import.meta.url).href,
  invite: new URL('./images/invite.png', import.meta.url).href,
  inviteRewards: new URL('./images/invite_rewards.png', import.meta.url).href,
  inviteCopy: new URL('./images/invite_copy.png', import.meta.url).href,

  // L
  left: new URL('./images/left.png', import.meta.url).href,
  like: new URL('./images/like.png', import.meta.url).href,
  list: new URL('./images/list.png', import.meta.url).href,
  link: new URL('./images/link.png', import.meta.url).href,
  logo: new URL('./images/logo.png', import.meta.url).href,
  logoMini: new URL('./images/logo_mini.png', import.meta.url).href,

  // M model_upload_bad_face
  movement: new URL('./images/movement.png', import.meta.url).href,
  more: new URL('./images/more.png', import.meta.url).href,
  modelUploadBadBlur: new URL('./images/model_upload_bad_blur.png', import.meta.url).href,
  modelUploadBadCover: new URL('./images/model_upload_bad_cover.png', import.meta.url).href,
  modelUploadBadFace: new URL('./images/model_upload_bad_face.png', import.meta.url).href,
  modelUploadGoodFemale: new URL('./images/model_upload_good_female.png', import.meta.url).href,
  modelUploadGoodMale: new URL('./images/model_upload_good_male.png', import.meta.url).href,

  // N
  new: new URL('./images/new.png', import.meta.url).href,
  none: new URL('./images/none.png', import.meta.url).href,
  noneData: new URL('./images/none_data.png', import.meta.url).href,
  notice: new URL('./images/notice.png', import.meta.url).href,

  // P
  policeBadge: new URL('./images/police_badge.png', import.meta.url).href,
  playCircle: new URL('./images/play-circle.png', import.meta.url).href,
  plus: new URL('./images/plus.png', import.meta.url).href,

  // R
  refresh: new URL('./images/refresh.png', import.meta.url).href,
  replace: new URL('./images/replace.png', import.meta.url).href,
  replace2: new URL('./images/replace2.png', import.meta.url).href,
  right: new URL('./images/right.png', import.meta.url).href,

  // S
  sceneUploadGood01: new URL('./images/scene_upload_good_01.png', import.meta.url).href,
  sceneUploadGood02: new URL('./images/scene_upload_good_02.png', import.meta.url).href,
  sceneUploadBad01: new URL('./images/scene_upload_bad_01.png', import.meta.url).href,
  sceneUploadBad02: new URL('./images/scene_upload_bad_02.png', import.meta.url).href,
  send: new URL('./images/send.png', import.meta.url).href,
  sort: new URL('./images/sort.png', import.meta.url).href,
  sort2: new URL('./images/sort2.png', import.meta.url).href,
  step1: new URL('./images/step1.png', import.meta.url).href,
  step2: new URL('./images/step2.png', import.meta.url).href,
  step3: new URL('./images/step3.png', import.meta.url).href,
  subscription: new URL('./images/subscribe_logo.png', import.meta.url).href,
  star: new URL('./images/star.png', import.meta.url).href,

  // T
  time: new URL('./images/time.png', import.meta.url).href,
  tutorial: new URL('./images/tutorial.png', import.meta.url).href,

  // U
  up: new URL('./images/up.png', import.meta.url).href,
  upload: new URL('./images/upload.png', import.meta.url).href,
  uploadLogo: new URL('./images/upload_logo.png', import.meta.url).href,
  uploadImg: new URL('./images/upload_img.png', import.meta.url).href,
  upTop: new URL('./images/up_top.png', import.meta.url).href,

  // V
  video: new URL('./images/video.png', import.meta.url).href,
  video1: new URL('./images/video1.png', import.meta.url).href,
  vip: new URL('./images/vip.png', import.meta.url).href,
  vip3: new URL('./images/vip3.png', import.meta.url).href,
  vip4: new URL('./images/vip4.png', import.meta.url).href,
  vipPrivilege: new URL('./images/vip_privilege.png', import.meta.url).href,

  // W
  warn: new URL('./images/warn.png', import.meta.url).href,
  warning: new URL('./images/warning.png', import.meta.url).href,
  wearUploadDemo01: new URL('./images/wear_upload_demo_01.png', import.meta.url).href,
  wearUploadDemo02: new URL('./images/wear_upload_demo_02.png', import.meta.url).href,
  wearUploadDemo03: new URL('./images/wear_upload_demo_03.png', import.meta.url).href,
  wearUploadDemo04: new URL('./images/wear_upload_demo_04.png', import.meta.url).href,

  // X
  xuzhi001: new URL('./images/xuzhi_001.png', import.meta.url).href,
  xuzhi002: new URL('./images/xuzhi_002.png', import.meta.url).href,

  // Z
  zoom: new URL('./images/zoom.png', import.meta.url).href,
}

// 默认导出
export default images
